import React from 'react'
import { Validator } from '@/components/validation'

export class ServerValidator extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      fetching: false,
      serverValidationResult: null,
      error: null
    }
    this._unmouted = false
  }
  componentDidMount () {
    this.validateOnServer(this.props.value)
  }
  componentWillUnmount () {
    this._unmouted = true
  }

  validateOnServer = (value) => {
    this.setState({ fetching: true }, () => {
      this.props.serverValidation(value)
        .then(serverValidationResult => {
          if (!this._unmouted) {
            this.setState({ serverValidationResult, fetching: false })
          }
        })
        .catch(error => {
          if (!this._unmouted) {
            this.setState({ fetching: false, error })
          }
        })
    })
  }
  onValidate = ({ value }) => {
    if (typeof this.props.onValidate === 'function') {
      const localValidation = this.props.onValidate({ value })
      if (localValidation) { return localValidation }
    }
    const { fetching, serverValidationResult, error } = this.state

    if (error) { return 'Validations.ErrorOccurred' }
    if (fetching) { return 'Validations.Fetching' }
    if (serverValidationResult) { return serverValidationResult }
  }
  onBlur = (e) => {
    const { value } = e.target
    this.validateOnServer(value)
  }
  onChange = (e, originalOnChange) => {
    this.setState({ serverValidationResult: null, error: null })
    if (typeof originalOnChange === 'function') { originalOnChange(e) }
  }
  render () {
    const { name, value, required, regex, maxLength } = this.props
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        value,
        onBlur: this.onBlur,
        onChange: (e) => this.onChange(e, child.props.onChange)
      })
    })
    return (
      <Validator name={name} value={value} required={required} regex={regex} onValidate={this.onValidate} maxLength={maxLength}>
        {children}
      </Validator>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/validation/serverValidator.js